var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.79089 8C4.79089 8.95346 4.01731 9.72796 3.06292 9.72796C2.10853 9.72796 1.33496 8.95346 1.33496 8C1.33496 7.04653 2.10853 6.27203 3.06292 6.27203C4.01731 6.27203 4.79089 7.04653 4.79089 8ZM9.72792 8C9.72792 8.95346 8.95343 9.72796 7.99996 9.72796C7.0465 9.72796 6.272 8.95346 6.272 8C6.272 7.04653 7.0465 6.27203 7.99996 6.27203C8.95343 6.27203 9.72792 7.04653 9.72792 8ZM11.209 8C11.209 7.04653 11.9835 6.27203 12.937 6.27203C13.8905 6.27203 14.665 7.04653 14.665 8C14.665 8.95346 13.8905 9.72796 12.937 9.72796C11.9835 9.72796 11.209 8.95346 11.209 8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.21c958f5e2ef41f413270a3352ec6c12.svg";
export { ForwardRef as ReactComponent };